export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/editor.worker.5395b8e3.worker.js");
}
